import {Injectable} from "@angular/core";
import {AbstractControl, FormGroup, ValidatorFn} from "@angular/forms";
import {EMAIL_APPLICANT_ERROR_KEY, PHONE_APPLICANT_ERROR_KEY, SSN_APPLICANT_ERROR_KEY} from "src/app/shared/constants";

@Injectable({
  providedIn: "root"
})
export class ApplicantValidator {
  // SSN, Email and Phone number must be different between applicants
  public uniqueData(): ValidatorFn {
    return (control: AbstractControl) => {
      const formGroup = control as FormGroup;

      if (formGroup.value.applicants.length > 1) {
        const error: any = {};
        const ssnArray: string[] = [],
          emailArray: string[] = [],
          phoneArray: string[] = [];

        formGroup.value.applicants.forEach((applicant: any) => {
          const {ssnNumber, emailAddress, phoneNumber} = applicant.tellUsAboutYourself;

          if (ssnNumber) ssnArray.push(ssnNumber);
          if (emailAddress) emailArray.push(emailAddress.toLowerCase());
          if (phoneNumber) phoneArray.push(phoneNumber);
        });

        if (!this._onlyUniqueValues(ssnArray)) {
          error[SSN_APPLICANT_ERROR_KEY] = true;
        }

        if (!this._onlyUniqueValues(emailArray)) {
          error[EMAIL_APPLICANT_ERROR_KEY] = true;
        }

        if (!this._onlyUniqueValues(phoneArray)) {
          error[PHONE_APPLICANT_ERROR_KEY] = true;
        }

        if (!!Object.keys(error).length) {
          return error;
        }
      }

      return null;
    }
  }

  private _onlyUniqueValues(array: Array<any>): boolean {
    if (!!array.filter(item => item === "").length) {
      return true;
    }
    return Array.from(new Set(array)).length === array.length;
  }
}
